import { colorsPalette, styled } from '@lingoda/ui/theme';
import { MenuItem as UiMenuItem } from '@lingoda/ui';
import type { ElementType } from 'react';

export const MenuItem = styled(UiMenuItem)<{ component: ElementType }>(({ theme }) => ({
    color: colorsPalette.blackSolid[100],
    fontSize: theme.typography.fontSize,
    textWrap: 'wrap',
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,

    transition: 'background 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),

    width: 300,
}));
